module.exports = __webpack_public_path__ + "static/media/13-Hamburg@3x.2bba83e9.jpg";